module.exports = __webpack_public_path__ + "img/login-logo.973636a8.png";